import React, { useState, useEffect } from 'react';
import SummaryDisplay from '../../MicroProbe//Companies/SummaryDisplayNews';
import { newsSummaryStock } from '../../../../services/newsSummary';

const StockPerformanceOverview = ({ companyData }) => {
    const [keyword, setKeyword] = useState('');
    const [summaryData, setSummaryData] = useState(null);
    const [isLoadingSummary, setIsLoadingSummary] = useState(false); 

    useEffect(() => {
        setKeyword(`${companyData.name} stock`);
    }, [companyData]);

    const fetchSummary = async () => {
        setIsLoadingSummary(true); 
        setSummaryData(null); 
        try {
            const summary = await newsSummaryStock(keyword); 
            setSummaryData(summary); 
        } catch (error) {
            console.error('Failed to fetch analysis:', error);
        }
        setIsLoadingSummary(false); 
    }

    const handleSearchClick = () => {
        fetchSummary();
    }

    const isLoading = isLoadingSummary;

    return (
        <div>
            <h3>Overview</h3>
       
            <div style={{ marginBottom: '20px' }}>
                <button onClick={handleSearchClick}>Stock Highlights</button>
                {isLoading && <div>Thinking, please wait …</div>}
                {summaryData && <SummaryDisplay summary={summaryData.response} />} 
            </div>
        </div>
    );
}

export default StockPerformanceOverview;